<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import Modal from '@apparatix/Components/Modal.vue';
import type { OfferSubmissionDocument, OfferSubmissionMode } from '@apparatix/types/Documents';
import OfferSubmissionForm from './OfferSubmissionForm.vue';
import { documentSubtitle, formCopy } from './offerSubmissionCopy';

type Props = {
  visible: boolean;
  document: OfferSubmissionDocument;
  mode: OfferSubmissionMode;
  isEssentials?: boolean;
};

type Emits = {
  (e: 'close'): void;
  (e: 'submitted'): void;
};

const props = withDefaults(defineProps<Props>(), {
  isEssentials: false,
});
const emit = defineEmits<Emits>();

const title = computed(() => formCopy(props.mode, props.isEssentials).title);
const subtitle = computed(() => documentSubtitle(props.document));

// remount the form on every open so the previous file selection is cleared
const formKey = ref(0);
watch(() => props.visible, isVisible => {
  if (isVisible) {
    formKey.value += 1;
  }
});
</script>

<template>
  <Modal
    :visible="props.visible"
    :title="title"
    :subtitle="subtitle"
    width="w-screen lg:w-[60vw] xl:w-[36rem]"
    height="h-auto max-h-[95vh]"
    disable-footer
    close-on-mask
    @close="emit('close')"
  >
    <template #body>
      <OfferSubmissionForm
        :key="formKey"
        :proposal-id="props.document.proposalId"
        :mode="props.mode"
        :is-essentials="props.isEssentials"
        @cancel="emit('close')"
        @submitted="emit('submitted')"
      />
    </template>
  </Modal>
</template>
